import { useModal, create, show } from "@ebay/nice-modal-react";

import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageFlows } from "hooks/useAnalytics/pages/flows";
import useFlowsProjectRoleBindingDelete from "shared/Flows/Projects/useFlowsProjectRoleBindingDelete";

type FlowsProjectRoleUnassignConfirmationProps = {
  id: string;
  name: string;
  refetchQueries: string[];
  source: "drawer" | "table";
};

const FlowsProjectRoleUnassignConfirmation = create(function FlowsProjectRoleUnassignConfirmation({
  id,
  name,
  refetchQueries,
  source,
}: FlowsProjectRoleUnassignConfirmationProps) {
  const modal = useModal();
  const { reportSuccess } = useTypedContext(FlashContext);
  const trackSegmentEvent = useAnalytics({
    page: AnalyticsPageFlows.FlowsProjectRoles,
  });

  const [deleteFlowsProjectRoleBinding, { loading }] = useFlowsProjectRoleBindingDelete({
    refetchQueries,
  });

  const handleOnConfirm = () => {
    deleteFlowsProjectRoleBinding(
      {
        id,
      },
      (data) => {
        if (data?.flowsProjectRoleBindingDelete?.id) {
          reportSuccess({
            message: "Role assignment successfully removed",
          });
          trackSegmentEvent("Flows project role binding removed", { source });
          modal.resolve();
          modal.hide();
        }
      }
    );
  };

  return (
    <DeleteConfirmationModal
      isLoading={loading}
      isDismissable={!loading}
      title="Unassign role"
      confirmationButtonLabel="Unassign"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to unassign the role{" "}
        <Typography tag="span" variant="p-t7">
          {name}
        </Typography>
        ? You cannot undo this action.
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showFlowsProjectRoleUnassignConfirmation = (
  props: FlowsProjectRoleUnassignConfirmationProps
) => show(FlowsProjectRoleUnassignConfirmation, props);
